import { PropsWithoutRef } from 'react';
import DebounceInput, {
  DebounceInputProps,
} from 'shared/components/DebounceInput';
import Input, { InputProps, inputClasses } from 'shared/components/Input';

import createSvgIcon from 'shared/utils/createSvgIcon';
import styled from 'shared/utils/styled';

type Props<Debounce extends boolean | undefined> = {
  debounce?: Debounce;
} & (Debounce extends true ? DebounceInputProps : InputProps);

const Component = <Debounce extends boolean | undefined>({
  debounce = false,
  ...rest
}: PropsWithoutRef<Props<Debounce>>) => {
  return debounce ? <DebounceInput {...rest} /> : <Input {...rest} />;
};

const SearchIcon = createSvgIcon(
  <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
);

export const StyledInput = styled(Component)(() => ({
  [`& .${inputClasses.input}`]: {
    padding: 5,
    paddingRight: 25,
  },
}));

export const Root = styled('div')(({ theme }) => ({
  position: 'relative',
  font: `400 ${theme.typography.pxToRem(16)} NeoSansStd`,
  background: '#fff',
  color: '#000',
}));

export const StyledSearchIcon = styled(SearchIcon)(() => ({
  position: 'absolute',
  top: '50%',
  right: 5,
  fontSize: '1.4rem',
  color: '#224060',
  transform: 'scale(-1,1) translateY(-50%)',
}));
